import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap"
import { ImAttachment } from "react-icons/im";
import { RiDeleteBin2Line } from "react-icons/ri";
import { withTranslation } from "react-i18next";
import moment from 'moment'
import { app } from '../../firebaseConfig'
import SimpleLoad from "../../loader/SimpleLoad";
import Post from "../../api/Post";
import Get from "../../api/Get";
import Delete from "../../api/Delete";
import { DOCUMENT_ADD_BY_APPOINTMENT, DOCUMENT_DELETE, DOCUMENT_GET_BY_APPOINTMENT } from '../../api/Routes'
import { getIconDoc } from "../../utils/getIconDoc";
import { BsArrowClockwise } from "react-icons/bs";
import ComponentModalErrorSever from '../../components/ComponentModalErrorSever'

 function ProvArchivos({t, appointmentId, auth, readOnly}){
    const fileInputField = useRef(null);
    const [errorFile, setErrorFile] = useState('')
    const [loading, setLoading] = useState(false)
    const [archivos, setArchivos] = useState([])
    const [reload, setReload] = useState(true)

    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    useEffect(()=>{
        if(reload){
            let mounted = true;
            setLoading(true)
            Get({url: `${DOCUMENT_GET_BY_APPOINTMENT}/${appointmentId}`, access_token: auth.data.access_token})
            .then(response=>{
                if(mounted){
                    if(response.data.data.response.length > 0){
                        setArchivos(response.data.data.response)
                    }                
                    setReload(false)
                    setLoading(false)   
                }
            })
            .catch(error=>{
                setReload(false)
                setLoading(false)
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
            })
            return () => mounted = false;
        }
    },[reload])

    const handleNewFileUpload = async (e) => {
        const file = e.target.files[0];

        let fileExtension = file.name.split('.').pop();
        
        if(fileExtension==='exe' || fileExtension==='apk'){
            setErrorFile(t('documento_no_valido'))
        }else{
            setErrorFile('')
            setLoading(true)
            //subimos el archivo a firebase y luego lo salvamos            
            const storageRef = app.storage().ref();
            const fileRef = storageRef.child('documents/' +file.name);
            await fileRef.put(file);
            let fileUrl = await fileRef.getDownloadURL();
            if(fileUrl){
                let d = {
                    fileName:file.name,
                    url:fileUrl,
                    appointment:{
                        id: appointmentId
                    },
                    uploadUser:{
                        email: auth.data.username
                    }
                }
                Post({url: DOCUMENT_ADD_BY_APPOINTMENT, data: d, access_token: auth.data.access_token, header: true})
                .then(response=>{
                    let arr = [...archivos]
                    arr.push(response.data.data)
                    setArchivos(arr)
                    setLoading(false)
                })
                .catch(error=>{
                    setShowModalError(true)
                    if(error.response){
                        setErrorServer(error.response)
                    }
                    setLoading(false)
                })
            }else{
                setLoading(false)
            }
        }
    };

    const seeDocument = url => window.open(url, "_blank", "toolbar=yes,resizable=yes")

    const deleteFile = (fileName, fileId) =>{
        setLoading(true)
        Delete({url: `${DOCUMENT_DELETE}/${fileId}`, access_token: auth.data.access_token})
        .then(response=>{
            setArchivos(archivos.filter(elem=>elem.id!==fileId))
            setLoading(false)
        })
        .catch(error=>{
            setLoading(false)
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }

    return (
        <div className="p-3 pt-4 position-relative">
            {loading && <SimpleLoad />}
            {
                archivos.map((item, i)=>(
                    <Card className="shadow-sm mb-3 cursor-pointer" key={i} onClick={e=>seeDocument(item.url)}>
                        <Card.Body className="py-1">
                            <div className="d-flex align-items-center">
                                <div className="pr-2">
                                    {getIconDoc(item.fileName)}
                                </div>
                                <div className="lh-1">
                                    <span className="d-block m-0 color-989898 font-size-09rem">{item.fileName}</span>
                                    <small className="color-989898">{moment(item.createDate).format("MMMM DD, YYYY HH:mm")}</small>
                                </div>
                                {(item.uploadUser && !readOnly) && <div className='ml-auto'>
                                    <span className="z-index-8 cursor-pointer" onClick={e=>{
                                        e.stopPropagation()
                                        deleteFile(item.fileName, item.id)
                                    }}><RiDeleteBin2Line className="color-red" /></span>
                                </div>}
                            </div>
                        </Card.Body>
                    </Card>
                ))
            }
            {!readOnly &&
            <Row>
                <Col xs="8" md="7">
                    <label className="font-weight-bold-600 color-yellow font-size-09rem d-block">{t('agregar_archivo')}</label>
                </Col>
                <Col xs="4" md="5" className="text-right">
                    <Button variant="light" size="sm" onClick={e=>setReload(true)}><BsArrowClockwise /> {t('actualizar')}</Button>
                </Col>
                <Col xs="12" md="12">                    
                    {errorFile && <small className="color-red">{errorFile}</small>}
                </Col>

                <Col xs="12" md="12">
                    <button type="button" className="btn-block btn-file">
                        <ImAttachment className="d-block m-auto color-989898 font-size-13rem"/>
                        <span className='d-block color-989898 font-size-09rem'>Subir archivo</span>
                    </button>
                    <input
                        type="file"
                        ref={fileInputField}
                        className="input-file"
                        onChange={handleNewFileUpload}
                    />                    
                </Col>
            </Row>}

            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
        </div>
    )
}

export default withTranslation()(ProvArchivos)
